import Service from '@ember/service';

import copy from 'copy-text-to-clipboard';

export default class ClipboardService extends Service {
  copy(text: string, options = {}): boolean {
    return copy(text, options);
  }
}
